export default {
    init() {
        let $filterForm = $("#event-filters");

        $("select", $filterForm).on("change", function () {
            $filterForm.trigger('submit');
        });

        $("button", $filterForm).on("click", function () {
            $("select", $filterForm).each(function () {
                $(this).val($('option:first', $(this)).val());
            })
        })
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
}



// WEBPACK FOOTER //
// ./scripts/routes/events.js